import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    // Behavior
    session: null,
    exists: false,
    step: 0,
    // Email
    email: null,
    // Personal
    name: null,
    family_name: null,
    gender: null,
    birthday: null,
    rut: null,
    nationality: null,
    birth_country: null,
    marital_status: null,
    spouse_name: null,
    spouse_family_name: null,
    spouse_rut: null,
    // Profiling
    profiling: null,
    referredFrom: null,
    // Contact
    phone: null,
    street: null,
    region: null,
    locality: null,
    street_number: null,
    country: null,
    house_type: null,
    interior_number: null,
    // Declarations
    isFatca: null,
    isCrs: null,
    isPep: null,
    isQualified: null,
    tinValues: null,
    isPolitician: null,
    isPoliticianFamily: null,
    isPoliticianAssociate: null,
  },
  mutations: {
    cleanState(state) {
      state.exists = null;
      state.email = null;
      state.session = null;
      state.name = null;
      state.family_name = null;
      state.gender = null;
      state.birthday = null;
      state.rut = null;
      state.birth_country = null;
      state.nationality = null;
      state.marital_status = null;
      state.spouse_name = null;
      state.spouse_family_name = null;
      state.spouse_rut = null;
      state.profiling = null;
      state.referredFrom = null;
      state.phone = null;
      state.street = null;
      state.region = null;
      state.locality = null;
      state.street_number = null;
      state.country = null;
      state.house_type = null;
      state.interior_number = null;
      state.isFatca = null;
      state.isCrs = null;
      state.isPep = null;
      state.isQualified = null;
      state.isQualifiedOption = null;
      state.tinValues = null;
      state.isPolitician = null;
      state.isPoliticianFamily = null;
      state.isPoliticianAssociate = null;
    },
    updateEmail(state, payload) {
      state.email = payload.email;
    },
    updateSession(state, payload) {
      state.session = payload.session ? payload.session : null;
    },
    updatePersonalData(state, payload) {
      state.name = payload.name;
      state.family_name = payload.family_name;
      state.gender = payload.gender;
      state.birthday = payload.birthday;
      state.rut = payload.rut;
      state.birth_country = payload.birth_country;
      state.nationality = payload.nationality;
      state.marital_status = payload.marital_status;
      state.spouse_name = payload.spouse_name;
      state.spouse_family_name = payload.spouse_family_name;
      state.spouse_rut = payload.spouse_rut;
    },
    updateProfilingData(state, payload) {
      state.profiling = payload.profiling;
      state.referredFrom = payload.referredFrom;
    },
    updateContactData(state, payload) {
      state.phone = payload.phone;
      state.street = payload.street;
      state.region = payload.region;
      state.locality = payload.locality;
      state.street_number = payload.street_number;
      state.country = payload.country;
      state.house_type = payload.house_type;
      state.interior_number = payload.interior_number;
    },
    updateDeclarationData(state, payload) {
      state.isFatca = payload.isFatca;
      state.isCrs = payload.isCrs;
      state.isPep = payload.isPep;
      state.isQualified = payload.isQualified;
      state.isQualifiedOption = payload.isQualifiedOption;
      state.tinValues = payload.tinValues;
      state.isPolitician = payload.isPolitician;
      state.isPoliticianFamily = payload.isPoliticianFamily;
      state.isPoliticianAssociate = payload.isPoliticianAssociate;
    },
    updateFormStep(state, payload) {
      state.step = payload.step ? payload.step : 0;
    },
    updateExists(state, payload) {
      state.exists = payload;
    },
    updateName(state, payload) {
      state.name = payload.name;
      state.family_name = payload.family_name;
    },
  },
  actions: {},
  plugins: [vuexLocal.plugin],
});
